import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  FILETYPE_LIST_ERROR,
  FILETYPE_LIST_LOADING,
  FILETYPE_LIST_RESET,
  FILETYPE_LIST_VIEW,
  FILETYPE_LIST_SUCCESS
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  view: []
};

function error(error) {
  return {type: FILETYPE_LIST_ERROR, error};
}

function loading(loading) {
  return {type: FILETYPE_LIST_LOADING, loading};
}

function success(items) {
  return {type: FILETYPE_LIST_SUCCESS, items};
}

function view(items) {
  return { type: FILETYPE_LIST_VIEW, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  view: state => state.view
};

const actions = {
    getItems({ commit }, page = '/file_types') {
      commit(loading(true));
      commit(error(null));

      return http.fetch(page)
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(view(data['hydra:view']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    }
};

const mutations = {
    [FILETYPE_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [FILETYPE_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [FILETYPE_LIST_VIEW] (state, payload) {
      state.view = payload.items;
    },
    [FILETYPE_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [FILETYPE_LIST_RESET] (state) {
      state.items = [];
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filetype/list.js